import { render, staticRenderFns } from "./add.vue?vue&type=template&id=76dabdf9&scoped=true&"
import script from "./add.vue?vue&type=script&lang=js&"
export * from "./add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76dabdf9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76dabdf9')) {
      api.createRecord('76dabdf9', component.options)
    } else {
      api.reload('76dabdf9', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=76dabdf9&scoped=true&", function () {
      api.rerender('76dabdf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/account/add.vue"
export default component.exports